// S20-94 - persistent hamburger utility panel
//
// S20-94 (mobile menu): snippets/utility-menu.liquid can render this toggle+panel
// pair more than once on the same page - once for the desktop panel next to the
// main nav ("Desktop..." ids) and once as the mobile hamburger menu ("Mobile..."
// ids), each with a unique id prefix so they never collide. Rather than hardcode
// either prefix, every toggle button on the page is found generically via the
// shared .utility-menu-toggle class, and each one's own panel is looked up by its
// own aria-controls attribute - so this same code drives any number of instances
// without knowing which ids they use.
document.addEventListener('DOMContentLoaded', function () {
  var toggles = document.querySelectorAll('.utility-menu-toggle');

  for (var i = 0; i < toggles.length; i++) {
    initUtilityMenu(toggles[i]);
  }

  function initUtilityMenu(toggle) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;

    // The panel is a position: fixed drawer, but it is rendered inside the
    // sticky header, and that header animates with a transform - which makes
    // "fixed" resolve against the header instead of the viewport (the drawer
    // showed up indented and hanging below the nav row). Re-parenting it to
    // <body> once, on init, gives it the viewport as its containing block so
    // it pins to the window's left edge, top to bottom. The toggle still finds
    // it by id, and every class-based style still applies.
    if (panel.parentNode !== document.body) {
      document.body.appendChild(panel);
    }

    // Both instances are full-height drawers (full screen on mobile, pinned to
    // the left edge on desktop), so the page behind must not scroll while one
    // is open - otherwise a wheel or swipe over the drawer scrolls the page
    // underneath it.
    function setScrollLock(locked) {
      document.documentElement.style.overflow = locked ? 'hidden' : '';
      document.body.style.overflow = locked ? 'hidden' : '';
    }

    function close() {
      toggle.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
      setScrollLock(false);
    }

    function open() {
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      setScrollLock(true);
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        close();
      } else {
        open();
      }
    });

    // The drawer covers the header, so the toggle's own X icon sits behind it -
    // the close button in the drawer's logo row is what the user actually taps
    // to dismiss it, along with the scrim and Escape.
    var closeButton = panel.querySelector('.utility-menu-panel__close');
    if (closeButton) {
      closeButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        close();
      });
    }

    // S20-94: on desktop the utility panel and the main nav's mega dropdowns
    // both hang off the same header row, so leaving the panel open while the
    // user reaches for a top-level nav item stacks two overlays on top of each
    // other. Moving the pointer onto the tier-1 nav list is a clear signal the
    // user is done with the panel, so dismiss it. The listener goes on the
    // tier-1 container (the toggle's sibling in .navigation-bar__row) rather
    // than the whole nav, so hovering the hamburger itself doesn't close it;
    // the panel sits below that row and never overlaps it, so moving from the
    // hamburger down into the panel doesn't cross this element either.
    // Drawer instances are skipped: the mobile drawer covers the nav entirely
    // and touch input doesn't emit mouseenter.
    // (Hover-out dismissal removed: the drawer now covers the hamburger and
    // sits over the page, so it closes on the X, the scrim or Escape only.)

    // S20-94: accordion for Utility link rows that have submenu children -
    // expands in place, independently per row.
    var accordionToggles = panel.querySelectorAll('.utility-menu-panel__toggle');
    for (var j = 0; j < accordionToggles.length; j++) {
      accordionToggles[j].addEventListener('click', function (e) {
        e.preventDefault();
        var sublist = document.getElementById(this.getAttribute('aria-controls'));
        if (!sublist) return;
        var isOpen = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        sublist.hidden = isOpen;
      });
    }

    document.addEventListener('click', function (e) {
      if (!panel.contains(e.target) && e.target !== toggle) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }
});
